/**
 * Color palette for Orbit application
 * Colors are organized by their usage/purpose
 */

export const colors = {
	// Main/Secondary Background Colors
	backgroundOrange: '#fff8f6',
	backgroundGreen: '#ecedeb',
	backgroundBlue: '#ebecf5',

	// Tab and Nav-bar Background
	vanilla: '#faf0f0',

	// Primary Colors (darkOrange has more emphasis)
	darkOrange: '#a03c04',
	orange: '#d15f2a',

	// Cool primary (titles, CTAs paired with warm)
	blue: '#394080',
	blueDark: '#2a3068',

	// Secondary Color (ex. Filter, Add day Note)
	gold: '#ed9247',

	// Highlighted CTA Buttons (ex. Add Expense)
	green: '#3e734d',

	// Success / state colors
	success: '#2e7d4f',
	red: '#f36f6f',

	// Title Text Color or Icon Tints
	blackOrange: '#541202',
	blackGreen: '#2e4d37',

	// Normal/Low Emphasis Text
	black: '#262626',
	textMuted: '#5c5c5c',
	darkGrey: '#c7c7c7',

	// Neutral Colors
	white: '#FFFFFF',
	grey: '#f4f4f4',
} as const

// Type-safe color keys
export type ColorKey = keyof typeof colors

// Helper function to get a color by key
export const getColor = (key: ColorKey): string => colors[key]

// Export individual colors for convenience
export const {
	backgroundOrange,
	backgroundGreen,
	backgroundBlue,
	vanilla,
	darkOrange,
	orange,
	blue,
	blueDark,
	gold,
	green,
	success,
	red,
	blackOrange,
	blackGreen,
	black,
	textMuted,
	darkGrey,
	white,
	grey,
} = colors

